























































































































































































































































































import Vue from 'vue'
import api from '../../../api'
import TransactionTimeline from '../../../components/TransactionTimeline.vue'

export default Vue.extend({
  components: { TransactionTimeline },

  props: {
    credit: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      loading: false,
      error: null as string | null,
      kkiapayResponse: null as any,
      retrying: false,
      syncing: false,
      checking: false,
      showFullJson: false,
      statusHistory: [] as any[]
    }
  },

  computed: {
    formattedJson(): string {
      return JSON.stringify(this.kkiapayResponse, null, 2)
    },
    shouldShowRetryButton(): boolean {
      if (!this.kkiapayResponse) return false
      const status = this.kkiapayResponse.status?.toLowerCase()
      return status === 'failed'
    },
    shouldShowSyncButton(): boolean {
      return !!this.credit?.transactionId
    },
    canManualCheck(): boolean {
      const state = this.credit?.state?.toLowerCase()
      return state === 'pending' || state === 'failed' || state === 'created'
    },
    retryCooldownActive(): boolean {
      if (!this.credit?.nextRetryAt) return false
      return new Date(this.credit.nextRetryAt).getTime() > Date.now()
    },
    nextRetryLabel(): string {
      if (!this.credit?.nextRetryAt) return ''
      const d = new Date(this.credit.nextRetryAt)
      return `${d.getHours()}h${String(d.getMinutes()).padStart(2, '0')}`
    },
    retryDisabled(): boolean {
      return this.retrying || this.retryCooldownActive
    },
    parsedError(): {
      status: string
      errorReasons: any[]
      transactionId: string
    } {
      if (!this.kkiapayResponse)
        return { status: '', errorReasons: [], transactionId: '' }

      const status = this.kkiapayResponse.status || 'N/A'
      const errorReasons: any[] = []
      const transactionId =
        this.kkiapayResponse.externalTransactionId ||
        this.kkiapayResponse.transactionId ||
        this.kkiapayResponse._id ||
        ''

      // Extraire errorReasons directement
      if (
        this.kkiapayResponse.errorReasons &&
        Array.isArray(this.kkiapayResponse.errorReasons)
      ) {
        errorReasons.push(...this.kkiapayResponse.errorReasons)
      }

      // Extraire de stateData.errorReasons
      if (
        this.kkiapayResponse.stateData?.errorReasons &&
        Array.isArray(this.kkiapayResponse.stateData.errorReasons)
      ) {
        errorReasons.push(...this.kkiapayResponse.stateData.errorReasons)
      }

      // Parser rawhistory si présent
      if (
        this.kkiapayResponse.rawhistory &&
        Array.isArray(this.kkiapayResponse.rawhistory)
      ) {
        this.kkiapayResponse.rawhistory.forEach((history: any) => {
          try {
            const historyData =
              typeof history === 'string' ? JSON.parse(history) : history
            if (historyData.response?.body) {
              const body = historyData.response.body
              if (body.message || body.description) {
                errorReasons.push({
                  status: body.status,
                  message: body.message || body.description
                })
              }
            }
          } catch (e) {
            // Ignore parsing errors
          }
        })
      }

      return { status, errorReasons, transactionId }
    }
  },

  methods: {
    async verifyTransaction() {
      this.loading = true
      this.error = null
      try {
        const response = await api.get(
          `/dispatching-credits/${this.credit.id}/verify-kkiapay`
        )
        if (response.data.error) {
          this.error = response.data.error
        } else {
          this.kkiapayResponse = response.data.kkiapayResponse
        }
        this.statusHistory = response.data.statusHistory || []
      } catch (err) {
        this.error =
          err.response?.data?.message || 'Erreur lors de la vérification'
      } finally {
        this.loading = false
      }
    },

    copyToClipboard() {
      const text = this.formattedJson
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          this.$notify.success('JSON copie dans le presse-papier')
        })
      }
    },

    async retryCredit() {
      if (!confirm('Etes-vous sur de vouloir relancer ce credit ?')) {
        return
      }

      this.retrying = true
      try {
        const { data } = await api.post(
          `/dispatching-credits/failed-credit/${this.credit.id}`
        )

        if (data && data.action === 'relaunched') {
          this.$notify.success('Le credit a ete relance avec succes')
        } else if (data && data.action === 'synced') {
          if (data.status === 'success') {
            this.$notify.success('Statut synchronise : credit reussi')
          } else if (data.status === 'pending') {
            this.$notify.success('Statut synchronise : paiement en cours')
          } else {
            this.$notify.success('Statut synchronise')
          }
        } else {
          this.$notify.success('Operation effectuee')
        }

        this.$emit('close')
        this.$emit('retry-success')
      } catch (err) {
        const errorMessage =
          err.response?.data?.message || 'Erreur lors de la relance du credit'
        this.$notify.error(errorMessage)
      } finally {
        this.retrying = false
      }
    },

    async syncTransaction() {
      this.syncing = true
      try {
        const { data } = await api.post(
          `/dispatching-credits/${this.credit.id}/check-status`
        )
        this.statusHistory = data.statusHistory || []
        if (data.success) {
          this.$notify.success(data.message || 'Synchronisation effectuee')
          await this.verifyTransaction()
          this.$emit('sync-success')
        } else {
          this.$notify.error(data.message || 'Transaction toujours en attente')
        }
      } catch (err) {
        const errorMessage =
          err.response?.data?.message || 'Erreur lors de la synchronisation'
        this.$notify.error(errorMessage)
      } finally {
        this.syncing = false
      }
    },

    async manualCheckStatus() {
      return this.syncTransaction()
    }
  },

  mounted() {
    this.verifyTransaction()
  }
})
